import React from "react";
import { Link } from "react-router-dom";

/**
 * Wonder Washers logo component.
 * Uses the master PNG at /assets/logo/wonder-washers-logo.png — used as-is per brand rules
 * (never traced, regenerated, or recolored beyond permitted derivatives).
 *
 * Variants:
 *   - "navy-on-light"  → full-color logo on white/light backgrounds (Variant 1, preferred)
 *   - "white-on-dark"  → full-color logo on solid navy #022A77 (Variant 2), wrapped in a subtle
 *                        white chip so the navy wordmark stays legible on the navy field. This
 *                        wraps the artwork — it does NOT modify it.
 */
export default function Logo({ variant = "navy-on-light", size = "md", to = "/" }) {
  const isDark = variant === "white-on-dark";
  const heights = { sm: 32, md: 48, lg: 72 };
  const h = heights[size] || heights.md;

  const img = (
    <picture>
      <source srcSet="/assets/logo/wonder-washers-logo.webp" type="image/webp" />
      <img
        src="/assets/logo/wonder-washers-logo.png"
        alt="Wonder Washers Pressure Washing"
        style={{ height: h, width: "auto", display: "block" }}
        loading="eager"
        decoding="sync"
      />
    </picture>
  );

  const inner = isDark ? (
    <span
      className="inline-flex items-center rounded-md bg-white"
      style={{ padding: `${Math.max(6, h * 0.12)}px ${Math.max(10, h * 0.2)}px` }}
    >
      {img}
    </span>
  ) : (
    img
  );

  if (!to) return inner;
  return (
    <Link to={to} aria-label="Wonder Washers Pressure Washing — home" className="inline-flex items-center">
      {inner}
    </Link>
  );
}
